import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import Button from 'orionsoft-parts/lib/components/Button'
import { withRouter } from 'react-router'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import autobind from 'autobind-decorator'

@withMutation(gql`
  mutation setFieldsName($documentId: ID, $fieldNames: JSON) {
    setFieldsName(documentId: $documentId, fieldNames: $fieldNames) {
      success
    }
  }
`)
@withMessage
@withRouter
export default class Save extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    router: PropTypes.object,
    document: PropTypes.object,
    value: PropTypes.object
  }

  state = {}

  @autobind
  async save() {
    this.setState({ loading: true, errorMessages: null })
    try {
      await this.props.setFieldsName(
        {
          documentId: this.props.document._id,
          fieldNames: this.props.value
        },
        {
          refetchQueries: ['getDocument', 'document']
        }
      )
      this.props.router.push(`/documents/${this.props.document._id}`)
      this.props.showMessage('información guardada')
    } catch (error) {
      this.props.showMessage(error.message, { level: 'error' })
      console.log('Error:', error)
    }
    this.setState({ loading: false })
  }

  render() {
    return (
      <div className={styles.container}>
        <Button
          primary
          disabled={!this.props.value}
          loading={this.state.loading}
          onClick={() => this.save()}
        >
          Guardar
        </Button>
        <Button
          onClick={() =>
            this.props.router.push(`/documents/${this.props.document._id}`)
          }
        >
          volver
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/FillNameFields/Fields/Save/index.js